export default (params) => ({
  trigger: {
    name: 'accessory_entrances.select_all',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'below_element',
          'below_subtitle',
        ],
      },
    },
    event: {
      name: 'select_all',
    },
  },
});
